// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_FinanceiroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /franquias/financeiro/{franquia_id}
 *
 * Returns four financial decimal fields from configuracao_franquia. MySQL
 * returns DECIMAL columns as strings via CodeIgniter's default driver, so
 * each field is typed as ?string.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Franquias_FinanceiroResponseDados {
investimento_total?: string
roe_desejado?: string
meta_faturamento_mensal?: string
meta_faturamento_anual?: string
}

export type Franquias_FinanceiroResponse = ApiResponse<Franquias_FinanceiroResponseDados>;

registerResponseContract('Franquias_FinanceiroResponse', {
  investimento_total:      { type: 'string',  required: false },
  roe_desejado:            { type: 'string',  required: false },
  meta_faturamento_mensal: { type: 'string',  required: false },
  meta_faturamento_anual:  { type: 'string',  required: false },
})
